export const CheckEntityVersion = {
    OK: 'OK',
    NOT_EXISTS: 'NOT_EXISTS',
    NOT_UPDATED: 'NOT_UPDATED',
};

export type CheckEntityVersionType = (typeof CheckEntityVersion)[keyof typeof CheckEntityVersion];
